module.exports = require("lodash/stubTrue");